import API from "@utils/request";
let Language = localStorage.getItem('currentLanguage');  //获取本地语言
let prout = 'protal';
if (!Language || Language == 'zh') {
    prout = 'protal';
} else {
    prout = 'protal_' + Language;
}


// 挑战赛-详情列表
export async function taskDetailList(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/taskDetailList", params);
    } catch (error) {
        return error;
    }
}

// 挑战赛-提交答案
export async function taskSubmit(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/taskSubmit", params);
    } catch (error) {
        return error;
    }
}

// 挑战赛-积分排行列表
export async function scoreList(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/scoreList", params);
    } catch (error) {
        return error;
    }
}

// 挑战赛-任务积分排行列表
export async function taskScoreList(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/taskScoreList", params);
    } catch (error) {
        return error;
    }
}
// 挑战赛-任务积分排行列表-每日每周一答
export async function answerScoreList(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/answerScoreList", params);
    } catch (error) {
        return error;
    }
}

// 挑战赛-积分详情
export async function scoreDetails(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/scoreDetails", params);
    } catch (error) {
        return error;
    }
}

// 挑战赛-我的积分详情
export async function myScore(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/myScore", params);
    } catch (error) {
        return error;
    }
}


// 挑战赛-挑战赛详情
export async function challengeinfo(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/info", params);
    } catch (error) {
        return error;
    }
}

// 挑战赛-挑战赛-阶段列表
export async function challengestageList(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/stageList", params);
    } catch (error) {
        return error;
    }
}

// 挑战赛-挑战赛详情-任务列表
export async function challengetaskInfo(params) {
    try {
        return await API.post("/api/" + prout + "/api/challenge/taskInfo", params);
    } catch (error) {
        return error;
    }
}
